export class logbogLaegekursusGruppeRequestModel {
    constructor(brugerKursusraekkeId: string, brugerId : string) {
        this.brugerKursusraekkeId = brugerKursusraekkeId;
        this.brugerId = brugerId;
    }
    brugerKursusraekkeId: string;
    brugerId: string;
}
